import React from "react";
import { Card, Statistic, Icon } from "semantic-ui-react";
import "./StatCard.scss";

export function StatCard(props) {
  const { title, value, icon, color, trend, loading = false } = props;

  return (
    <Card className={`stat-card ${color || ""}`} fluid>
      <Card.Content>
        <div className="stat-card-header">
          <div className="stat-card-icon" style={{ backgroundColor: color }}>
            <Icon name={icon} size="big" />
          </div>
          <div className="stat-card-content">
            <Statistic size="small">
              <Statistic.Value>{loading ? "..." : value}</Statistic.Value>
              <Statistic.Label>{title}</Statistic.Label>
            </Statistic>
            {trend && (
              <div className={`stat-card-trend ${trend.type}`}>
                <Icon name={trend.type === "up" ? "arrow up" : "arrow down"} />
                <span>{trend.value}%</span>
                <span className="trend-label">{trend.label}</span>
              </div>
            )}
          </div>
        </div>
      </Card.Content>
    </Card>
  );
}
